<template>
  <div class="live-lite-delivery">
    <p class="level-1">投放设置</p>

    <delivery :form="form" />

    <div class="ea-container">
      <optimize-target
        :externalActions="externalActions"
        :form="form"
        :top="220"
        cardTitle="预估带来直播间观看量"
      />
    </div>

    <budget-bit :form="form" budgetTitle="总预算" />

    <div class="during">
      <p class="level-2">投放时长</p>
      <p class="tips" v-show="form.creativeForm == '直播间画面'">
        <i class="el-icon-info"></i
        >仅直播时进行投放，投放时长与实际直播时长越接近效果越好，避免时长差异较大带来的消耗浪费过多或平均消耗过低
      </p>
      <el-input-number
        v-model="form.during"
        :step="0.5"
        :min="0.5"
        :max="24"
        size="small"
        style="margin-top: 10px"
      ></el-input-number>
      <span style="margin-left: 10px">小时 最多不超过24小时</span>
    </div>

    <audience-settings :form="form" />
  </div>
</template>

<script>
import AudienceSettings from "../components/audienceSettings.vue";
import BudgetBit from "../components/budgetBit.vue";
import customAudience from "../components/customAudience.vue";
import Delivery from "../components/delivery.vue";
import OptimizeTarget from "../components/optimizeTarget.vue";
export default {
  components: {
    customAudience,
    OptimizeTarget,
    BudgetBit,
    AudienceSettings,
    Delivery,
  },
  props: {
    form: Object,
  },
  data() {
    return {
      externalActions: [
        {
          icon: require("@/assets/images/simulation/icon_enter.svg"),
          name: "进入直播间",
          content: "更多人进入直播间",
        },
        {
          icon: require("@/assets/images/simulation/icon_click.svg"),
          name: "直播间商品点击",
          content: "更多人点击商品",
        },
        {
          icon: require("@/assets/images/simulation/icon_cart.svg"),
          name: "直播间下单",
          content: "更多人下单商品",
        },
        {
          icon: require("@/assets/images/simulation/icon_deal.svg"),
          name: "直播间成交",
          content: "更多人支付订单",
        },
        {
          icon: require("@/assets/images/simulation/icon_fans.svg"),
          name: "直播间粉丝提升",
          content: "更多人关注抖音号",
        },
        {
          icon: require("@/assets/images/simulation/icon_comment.svg"),
          name: "直播间评论",
          content: "更多人在直播间评论",
        },
      ],
    };
  },
};
</script>

<style lang="less" scoped>
.live-lite-delivery {
  margin-top: 56px;
  .level-1 {
    line-height: 34px;
    font-weight: 500;
    font-size: 24px;
    color: #111;
  }
  .level-2 {
    margin-top: 28px;
    margin-bottom: 12px;
    line-height: 20px;
    font-weight: 600;
    font-size: 14px;
    color: #333;
    .el-icon-question {
      margin-left: 3px;
      color: #d3d3d3;
      font-size: 16px;
      vertical-align: -1px;
      cursor: pointer;
    }
  }
  .ea-container {
    position: relative;
  }

  .during {
    .tips {
      margin-top: 12px;
      line-height: 20px;
      font-size: 12px;
      color: #333;
      .el-icon-info {
        margin-right: 5px;
        font-size: 16px;
        color: #969696;
        vertical-align: -2px;
      }
    }
    ::v-deep .el-input-number {
      .el-input-number__decrease,
      .el-input-number__increase {
        background: #fafafa;
      }
    }
  }
}
</style>